export default __webpack_public_path__ + "static/media/Spiritual Ward.0932ae0b.jpg";